import React from 'react';
import { observer } from 'mobx-react';
import Loader from 'react-simple-loading';
import FanItem from './FanItem';

import { RootStoreContext } from '../../../../../context';

import { ModeComment } from '@material-ui/icons';

import './FansList.css';

@observer
class FansList extends React.Component {

  static contextType = RootStoreContext;

  render () {
    const { privateMessagingStore: { fansList: { loading }, fansUsernames } } = this.context;
    return (
      <div id="anchor-chat-fans-list">
        {loading && <Loader size="20px" stroke="2px" />}
        {fansUsernames.length === 0 && !loading && <p className="no-fans">No fans</p>}
        {fansUsernames.length > 0 && (
          <>
            <p className="info-label">
              <span style={{ marginRight: '4px' }}>
                <ModeComment fontSize="inherit" />
              </span>
              Choose a fan and start a conversation
            </p>
            <ul className="fans-list">
              {fansUsernames.map(f => (
                <FanItem
                  key={f.user.username}
                  fan={f}
                />)
              )}
            </ul>
          </>
        )}
      </div>
    );
  }
}

export default FansList;